import { createFileRoute } from "@tanstack/react-router";
import GrandparentsGuideToModernDepressionTreatment from "@/pages/articles/GrandparentsGuideToModernDepressionTreatment";
export const Route = createFileRoute(
  "/grandparents-guide-to-modern-depression-treatment",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Grandparents Guide To Modern Depression Treatment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "A grandparent’s guide to modern depression treatment: TMS, SAINT TMS, SPRAVATO, and therapy explained in plain language in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Grandparents Guide To Modern Depression Treatment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "A grandparent’s guide to modern depression treatment: TMS, SAINT TMS, SPRAVATO, and therapy explained in plain language in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/grandparents-guide-to-modern-depression-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/grandparents-guide-to-modern-depression-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <GrandparentsGuideToModernDepressionTreatment />;
}
